import CopyTextWithButton from "components/basic/copy-text-with-button/CopyTextWithButton";
import React from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import T from "services/lang/LanguageService";
import { getMinMax, standardDeviation } from "utils/utils";
import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";

type DatasetStatusShowerProps = {
  dialog: boolean;
  setDialog: (val: boolean) => void;
  datasets: Array<DatasetDataInfoResponse>;
};

const DatasetStatusShower = ({ dialog, setDialog, datasets }: DatasetStatusShowerProps) => {
  const fixedTo = 2;
  const titleBodyTemplate = (rowData: any) => {
    return <CopyTextWithButton text={rowData.title} copyableText={rowData.title} />;
  };

  return (
    <Dialog visible={dialog} onHide={() => setDialog(false)} header={T("word.statistics")}>
      <DataTable
        removableSort
        sortMode="multiple"
        value={datasets.map(dataset => {
          const nrArr: Array<number> = dataset.data.map(e => e.value);
          const average = nrArr.reduce((x, y) => x + y) / nrArr.length;
          const sum = nrArr.reduce((x, y) => x + y);

          if (nrArr.length > 0) {
            const { min, max } = getMinMax(nrArr);
            return {
              ...dataset,
              average: average.toFixed(fixedTo),
              sum: sum.toFixed(fixedTo),
              min: min.toFixed(fixedTo),
              max: max.toFixed(fixedTo),
              count: nrArr.length,
              delta: (max - min).toFixed(fixedTo),
              std: standardDeviation(nrArr, average)?.toFixed(fixedTo),
            };
          }
          return dataset;
        })}
      >
        <Column header={T("word.title")} field="title" sortable body={titleBodyTemplate} />
        <Column
          header={T("word.unit")}
          field="unit"
          style={{ width: 0 }}
          body={data => data.unit || "-"}
          sortable
        />
        <Column
          header={T("action.count")}
          field="count"
          style={{ width: 0 }}
          body={data => data.count || "-"}
          sortable
        />
        <Column
          header={T("word.sum")}
          field="sum"
          style={{ width: 0 }}
          body={data => data.sum || "-"}
          sortable
        />
        <Column
          header={T("word.min")}
          field="min"
          style={{ width: 0 }}
          body={data => data.min || "-"}
          sortable
        />
        <Column
          header={T("word.max")}
          field="max"
          style={{ width: 0 }}
          body={data => data.max || "-"}
          sortable
        />
        <Column
          header={T("word.delta")}
          field="delta"
          style={{ width: 0 }}
          body={data => data.delta || "-"}
          sortable
        />
        <Column
          header={T("word.mean")}
          field="average"
          style={{ width: 0 }}
          body={data => data.average || "-"}
          sortable
        />
        <Column
          header={T("word.std")}
          field="std"
          style={{ width: 0 }}
          body={data => data.std || "-"}
          sortable
        />
      </DataTable>
    </Dialog>
  );
};

export default DatasetStatusShower;
